<template>
  <div>
    <v-dialog v-model="show" v-if="show" width="800" persistent>
      <v-card>
        <v-card-title class="justify-space-between">
          <template v-if="tab == 0">Upload Image</template>
          <template v-else>Edit Image</template>
          <!-- <v-btn v-else fab text small @click="tab = 0"><v-icon class="text-right">mdi-chevron-left</v-icon></v-btn> -->

          <v-btn fab text small @click="handleClose"
            ><v-icon class="text-right text--secondary">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <vue-dropzone
                ref="dropzone"
                id="Dropzone"
                :options="dropzoneOptions"
                @vdropzone-file-added="fileAdded"
                :useCustomSlot="true"
              >
                <p class="mt-n-10 text-body-1 primary--text">
                  Drag and drop or
                  <span class="text-decoration-underline">Browse files</span>
                </p>
              </vue-dropzone>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <!-- <v-card-title>
                  Edit Image
                </v-card-title> -->
                <v-card-text>
                  <ImageCropper
                    :selectedImage="selectedImage"
                    @uploaded="handleUploaded"
                    :previewType="previewType"
                    :key="refreshCropper"
                    :link="link"
                    :selectedLogoFrame="selectedlogoFrame"
                    :businessCardRotatorObject="businessCardRotatorObject"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ImageCropper from "@/components/ImageCropper";
import { mapActions, mapGetters } from "vuex";
import imageCompression from "browser-image-compression";
import {getStorageRef, uploadStringInStorage} from "@/shared/firebase_utils";

let uuid = require("uuid");

export default {
  props: {
    fab: { type: Boolean, default: false },
    previewType: { type: String, default: "reverseImageURL" },
    show: { type: Boolean, default: false },
    link: { type: Object },
    selectedlogoFrame: { type: String },
    businessCardRotatorObject: { type: Object },
    applyImageCompression: { type: Boolean, default: false },
    image: { type: String, default: "" },
    isBadgeOrQrCode: { type: Boolean, default: false },
    uploadToBusinessProfile: { type: Boolean, default: true },
    generateCompressedImage: { type: Boolean, default: false },
  },
  components: {
    vueDropzone: vue2Dropzone,
    ImageCropper,
  },
  data() {
    return {
      dropzoneOptions: {
        autoProcessQueue: false,
        url: "http://localhost",
        previewsContainer: false,
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
      },
      tab: 0,
      selectedImage: "",
      refreshCropper: 0,
      uploadedImageBase64String: "",
      uploadedFile: null,
    };
  },
  computed: {
    ...mapGetters(["linkInBio", "businessProfile"]),
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails"]),
    async fileAdded(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      this.uploadedFile = file;

      reader.onload = async (event) => {
        //event.target.result - is dataURL datas
        let base64String = event.target.result;
        this.uploadedImageBase64String = event.target.result;

        //Compress image before cropping for Badge, QR Code etc
        if (file.size > 1000000 && this.applyImageCompression) {
          const options = {
            maxSizeMB: 1,
          };

          let compressedFile = await imageCompression(file, options);
          base64String = await imageCompression.getDataUrlFromFile(
            compressedFile
          );
        }

        this.selectedImage = base64String;
        this.tab = 1;
        this.refreshCropper = 1;
      };
    },
    async handleUploaded(downloadURL, logoFrame) {
      //Badge and qr code image url will be uploaded to another property
      // !this.isBadgeOrQrCode;
      if (this.uploadToBusinessProfile) {
        this.businessProfile.imageURLs?.unshift(downloadURL);
        this.updateBusinessProfileDetails(this.businessProfile);
      }

      //Generate a compressed version of the uploaded image
      if (this.generateCompressedImage) {
        let options = {
          maxSizeMB: 0.3,
          maxWidthOrHeight: 1280,
          useWebWorker: true,
        };

        let compressedImage = await imageCompression(
          this.uploadedFile,
          options
        );
        let compressedBase64String = await imageCompression.getDataUrlFromFile(
          compressedImage
        );
        await this.uploadImage(compressedBase64String);
      }

      this.refreshCropper = 0;
      this.tab = 0;
      this.$emit("uploaded", downloadURL, this.previewType, logoFrame);
      this.$emit("close");
    },
    handleClose() {
      this.tab = 0;
      this.refreshCropper = 0;
      this.$emit("close");
    },
    async uploadImage(compressedImage) {
      try {
        //create a unique file name
        const imageName = uuid.v1();
        const metaData = {
          contentType: "image/png",
        };

        //Get a firebase storage reference

        const imageRef = getStorageRef(`images/${imageName}.png`);
        const uploadTask = await uploadStringInStorage(
            imageRef,
          compressedImage,
          "data_url",
          metaData
        );
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case 'paused': // or 'paused'
                console.log("Upload is paused");
                break;
              case 'running': // or 'running'
                this.imageUploadProgress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then((compressedImageDownloadURL) => {
                this.$emit(
                  "compressed-image-uploaded",
                  compressedImageDownloadURL
                );
              });
          }
        );
      } catch (error) {
        console.log("Error occurred while uploading the image ", error);
      }
    },
  },
};
</script>

<style scoped>
.fab {
  border-radius: 50%;
}

.cursor-pointer {
  cursor: pointer !important;
}
</style>
